(() => {
  const styleShadowButton = (host) => {
    const root = host.shadowRoot;
    if (!root || root.querySelector('[data-df-follow-color]')) return;

    const style = document.createElement('style');
    style.dataset.dfFollowColor = 'true';
    style.textContent = `
      :host,
      button,
      button span,
      button span svg {
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
      }

      button span svg path {
        fill: currentColor !important;
      }

      button > div:nth-of-type(2),
      button > div:nth-of-type(2) svg {
        color: #fff !important;
      }

      button > div:nth-of-type(2) svg path {
        fill: none !important;
        stroke: currentColor !important;
      }
    `;
    root.appendChild(style);
  };

  const refresh = () => {
    document
      .querySelectorAll('.follow-on-shop shop-follow-button')
      .forEach(styleShadowButton);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  customElements.whenDefined('shop-follow-button').then(refresh).catch(() => {});
  new MutationObserver(refresh).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
